import React from "react";

function TextAreav2({
  label,
  id,
  placeholder,
  required,
  maxLength,
  register = false,
  width = null,
  pattern,
  cols,
  rows,
  ...props
}) {
  return (
    <div
      className={`${width ? `mymd:w-[${width}] w-full` : "w-full"} ${
        props.mb
          ? `relative mb-${props.mb} w-full`
          : `relative mb-[28px] w-full`
      }`}
    >
      <label htmlFor={id} className="text-[14px] font-[500] pl-1">
        {required ? (
          <>
            {label}
            &nbsp;<span className="text-red-600">*</span>
          </>
        ) : (
          <>{label}</>
        )}
      </label>
      <textarea
        rows={rows ? rows : 3}
        id={id}
        cols={cols ? cols : 50}
        placeholder={placeholder}
        required={required}
        maxLength={maxLength}
        className={`w-full
 peer bg-[#F4F6F9] 
border-[#C5C5C7] border-[1px]
text-gray-900 text-[13px] rounded-lg placeholder-gray-400 focus:border-primary focus:border-[1px] block p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white font-medium dark:focus:ring-blue-500 dark:focus:border-blue-500 mt-1 focus:ring-1 focus:ring-primary`}
        {...register(id, {
          validate: (value) => {
            const trimmedValue = value.trim();
            if (value && trimmedValue === "") {
              return "Invalid input!!";
            }
            return true;
          },
        })}
        {...props}
      ></textarea>
    </div>
  );
}

export default TextAreav2;
